export default __webpack_public_path__ + "static/favicon-ef45c4a393ad528b7ba7b0bae3ce332a.svg";